export default __webpack_public_path__ + "2d514f88f5d0c168ff4f30fe692ea5d8.png";